export function ConvocoreCallout({ ui }) {
  return (
    <aside className="product-callout product-callout--convocore">
      <div className="product-callout__icon" aria-hidden="true">
        <img src="/convocore-logo.svg" alt="" />
      </div>
      <div className="product-callout__content">
        <span>CONVOCORE</span>
        <h2>{ui.convocoreTitle}</h2>
        <p>{ui.convocoreText}</p>
      </div>
      <a
        className="product-button product-button--primary"
        href="https://convocore.ai/?aff=miguelangel"
        target="_blank"
        rel="sponsored noopener noreferrer"
      >
        {ui.convocoreCta}
      </a>
    </aside>
  );
}

export function InstallationCallout({ ui, installationUrl }) {
  return (
    <aside className="product-callout product-callout--installation">
      <div className="product-callout__content">
        <span>FIKAMI LLC</span>
        <h2>{ui.installationTitle}</h2>
        <p>{ui.installationText}</p>
      </div>
      <a className="product-button product-button--primary" href={installationUrl}>
        {ui.installationCta}
      </a>
    </aside>
  );
}
